// extracted by css-extract-rspack-plugin
export default {"select":"wHGWiCTHVVkSsMhk__select___"};